export const ACCOUNT_DETAILS_JSON =  "ACCOUNT_DETAILS_JSON";
